import { useEffect, useRef } from 'react'
import validatorjs from 'validatorjs';
import messagesValidator from 'helpers/validatorjs';
import { LoadingContextProvider } from 'context/LoadingContext'
import FormStatusRepair from 'components/Form/StatusRepair'


function AppStatusRepair() {
  const formRef = useRef(null)

  useEffect(() => {
    validatorjs.setMessages('pl', messagesValidator);
    validatorjs.useLang('pl');
  }, [])

  const successSend = () => {
    setTimeout(() => {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: "start", inline: "end"})
    })
  }

  return (
    <div ref={formRef} className="wrap-mik-form-application">
      <LoadingContextProvider>
        <div className="status">
          <FormStatusRepair success={successSend} />
        </div>
      </LoadingContextProvider>
    </div>
  )
}

export default AppStatusRepair;
